import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-[var(--omni-border)] bg-[var(--omni-surface)] mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="font-bold mb-3">OmniSearch</div>
          <p className="text-gray-500 leading-relaxed">Un moteur de recherche minimaliste, rapide, et respectueux de votre vie privée.</p>
        </div>
        <div>
          <div className="font-bold mb-3">Produit</div>
          <ul className="space-y-2 text-gray-600">
            <li><Link to="/about" className="hover:text-black" data-testid="footer-about">À propos</Link></li>
            <li><Link to="/settings" className="hover:text-black" data-testid="footer-settings">Paramètres</Link></li>
            <li><Link to="/contact" className="hover:text-black" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/help" className="hover:text-black" data-testid="footer-help">Aide</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-bold mb-3">Développeurs</div>
          <ul className="space-y-2 text-gray-600">
            <li><Link to="/developers" className="hover:text-black" data-testid="footer-developers">Portail API</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-bold mb-3">Compte</div>
          <ul className="space-y-2 text-gray-600">
            <li><Link to="/login" className="hover:text-black" data-testid="footer-login">Connexion</Link></li>
            <li><Link to="/register" className="hover:text-black" data-testid="footer-register">Créer un compte</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--omni-border)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 text-xs text-gray-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} OmniSearch. Construit avec respect.</span>
          <span className="font-mono opacity-60">v1.0.0 · sk-emergent</span>
        </div>
      </div>
    </footer>
  );
}
